import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import moment from "moment";
import { Button, Spin, DatePicker } from "antd";

import { handleError } from "../../modules/presence/sagas";
import FileSaver from "file-saver";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
// page temporaire utilisée une fois par an en cas de régularisation du montant des paniers repas.
// Elle permet de télécharger un document excel qui contient la liste des ndf pour lesquelles le montant du panier repas a été modifié.
const AccountingMealPackage = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [rangeDate, setRangeDate] = useState([
    moment()
      .startOf("week")
      .add(-1, "week"),
    moment().endOf("week")
  ]);
  const exportNDFMealPackagesSummary = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseapi}/expenses/export/mealpackagesexpensessummary/`,
        { startDate: rangeDate[0].format("YYYY-MM-DD"), endDate: rangeDate[1].format("YYYY-MM-DD") },
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      );

      FileSaver.saveAs(
        new Blob([response.data], { type: "application/vnd.ms-excel" }),
        `Résumé de l'ensemble des forfait repas du ${rangeDate[0].format("DD/MM/YYYY")} au ${rangeDate[1].format(
          "DD/MM/YYYY"
        )}.xlsx`
      );
    } catch (e) {
      console.log(e);
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Nombre de paniers repas par collaborateur sur une plage de date`}</div>
        </div>
        <div style={{ margin: 20 }}>
          <div style={{}}>
            Page temporaire utilisée une fois par an en cas de régularisation du montant des paniers repas.
          </div>
          <div>
            Elle permet de télécharger un document excel qui contient la liste des collaborateurs avec pour chacun le
            nombre de paniers repas accordé sur une plage de dates de donnée.
          </div>
        </div>
        <DatePicker.RangePicker
          onChange={selectedRangeDate => {
            setRangeDate(selectedRangeDate);
          }}
          defaultValue={rangeDate}
          format={"DD/MM/YYYY"}
          placeholder={["Début", "Fin"]}
        />
      </HeaderContainer>
      {isLoading ? (
        <Spin></Spin>
      ) : (
        <Button
          type="primary"
          onClick={async () => {
            await exportNDFMealPackagesSummary();
          }}
        >
          {`Télécharger le document des ndf forfaits repas du ${rangeDate[0].format(
            "DD/MM/YYYY"
          )} au ${rangeDate[1].format("DD/MM/YYYY")}`}
        </Button>
      )}
    </Container>
  );
};

export default AccountingMealPackage;



// WEBPACK FOOTER //
// src/pages/accounting/MealPackageUpdate.js